import React, { useMemo, forwardRef } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import Link, { LinkProps } from '../Link';

export interface InternalLinkProps extends Omit<LinkProps, keyof SCP<'a'>>, Omit<RouterLinkProps, 'to'>, Partial<Pick<RouterLinkProps, 'to'>> {
}

const InternalLink = forwardRef<HTMLAnchorElement, InternalLinkProps>(({ to, href, ...props }, ref) => {
  const path = useMemo(() => to || href, [href, to]);
  const As = useMemo(() => {
    // eslint-disable-next-line react/no-unstable-nested-components, react/prop-types
    const RouterLinkWrapper = forwardRef<
      HTMLAnchorElement,
      InternalLinkProps
    >(({ LeftIcon, RightIcon, ...p }, ref2) => (
      <RouterLink ref={ref2} {...p as RouterLinkProps} />));
    return RouterLinkWrapper;
  }, []);
  return (
    <Link<typeof RouterLink>
      to={path}
      data-testid="InternalLink"
      as={As}
      ref={ref}
      {...props}
    />
  );
});

export default InternalLink;
